module.exports = __webpack_public_path__ + "assets/point.266e2795.svg";